export default __webpack_public_path__ + "static/media/31.ce611811.jpg";